import { LegalPersonalityEnum, LegalPersonalityIdEnum } from 'src/app/domain/enums/legal-personality.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';

export class FormDataCreate {
  public async build(element: any): Promise<FormData> {
    let {
      name,
      type,
      
    } = element;

    let formData = new FormData();
      formData.append('name', name);
    formData.append('type',  type);
    

    return formData;
  }
}
